import React, { useState } from "react";

const data = [
  {
    title: "Board Meeting-13 Nov 25-Intimation",
    fileUrl: "https://assets.bharatrohan.in/BoardMeeting/BR-Cover_Letter-Intimation-F.pdf",
  },
  {
    title: "Board Meeting-13 Nov 25-Outcome",
    fileUrl: "https://assets.bharatrohan.in/BoardMeeting/BR-Cover_Letter-Outcome-FINAL.pdf"
  },
  {
    title: "Board Meeting-17 Feb 26-Outcome",
    fileUrl: "https://assets.bharatrohan.in/BoardMeeting/BM_Outcome-17Feb26.pdf"
  },
  {
    title: "Board Meeting-30 May 26-Intimation",
    fileUrl: "https://assets.bharatrohan.in/BoardMeeting/BM_cover_letter-SFinal.pdf"
  },
  {
    title: "Board Meeting-30 May 26-Outcome",
    fileUrl: "https://assets.bharatrohan.in/BoardMeeting/Board_Meeting-30_May_26-Outcome.pdf"
  },
  {
    title: "Board Meeting-17 July 26-Outcome",
    fileUrl: "https://assets.bharatrohan.in/BoardMeeting/17July26-BR-Outcome.pdf"
  },
  {
    title: "Board Meeting-4 Sep 26-Outcome",
    fileUrl: "https://assets.bharatrohan.in/BoardMeeting/BM_Outcome-4Sep26.pdf"
  }
];

export default function Share01() {
  const [selected, setSelected] = useState<number | null>(null);
  const [loadingIndex, setLoadingIndex] = useState<number | null>(null);
  const isMobile = window.innerWidth < 1024;

  const handleClick = (item: any, index: number) => {
    setSelected(index);
    if (item.fileUrl === "*") {
      setLoadingIndex(index);
      setTimeout(() => {
        setLoadingIndex(null);
      }, 2000); // show loading for 2 seconds
    } else {
      window.open(item.fileUrl, "_blank");
    }
  };

  return (
    <div className="py-8 lg:pb-10">
      <div className="flex flex-col lg:flex-row items-start gap-x-12 xl:gap-x-16 2xl:gap-x-20 gap-y-6 md:gap-y-12">
        <div className="grid w-full blade-top-padding-sm lg:pt-0 lg:w-[100%] gap-y-4 lg:gap-y-6 flex-col">
          {data.map((item, index) => (
            <div className="flex justify-around sm:flex" key={index}>
              <div className="md:w-[70%] sm:w-2">
                <div
                  onClick={() => handleClick(item, index)}
                  className={`flex w-full py-4 border px-4 sm:px-6 md:px-8 lg:px-4 xl:px-6 border-green items-center justify-between cursor-pointer transition-all duration-500 ${
                    selected === index
                      ? "bg-transparent cursor-auto pt-6"
                      : "bg-transparent"
                  }`}
                >
                  <div className="grid w-full grid-cols-[2.5rem_1fr_auto] sm:grid-cols-[3rem_1fr_auto] xl:grid-cols-[4rem_1fr_auto]">
                    <span className="text-lg lg:text-xl 2xl:text-xl opacity-25 font-bold text-black">
                      {index >= 9 ? `${index + 1}` : `0${index + 1}`}
                    </span>

                    <h4 className="text-green font-semibold text-left self-center 2xl:text-xl overflow-hidden">
                      {loadingIndex === index ? (
                        <span className="animate-pulse text-gray-500">Loading...</span>
                      ) : (
                        <div
                          className={`inline-block whitespace-nowrap ${
                            (isMobile && item.title.length > 25)
                              ? "animate-slide 2xl:animate-none px-2"
                              : item.title.length > 40
                              ? "animate-slide"
                              : "w-80"
                          }`}
                        >
                          {item.title}
                        </div>
                      )}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
